module.exports = __webpack_public_path__ + "img/transfer-list-white.4ea5a6a7.svg";